import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ModalStyled from '@components/modal/ModalStyled';
import { useMST } from '@hooks/MSTHook';
import { AnalyticsContextProvider, useAnalytics } from '@lusha-engage/analytics';
import dayjs from 'dayjs';
import { observer } from 'mobx-react';
import React, { useEffect, useMemo } from 'react';
import LeaveFeedbackView from './views/LeaveFeedbackView';
import RateTopView from './views/RateTopView';
import RateView from './views/RateView';
const RateExtensionModal = observer(() => {
    const { userActivity } = useMST(store => ({ userActivity: store.userActivity }));
    const { firstOpenedAt, totalContactRevealsCount } = userActivity;
    const analytics = useAnalytics();
    const isVisible = userActivity.isModalVisible;
    const days_since_installation = useMemo(() => {
        if (!firstOpenedAt)
            return undefined;
        return dayjs().diff(dayjs(firstOpenedAt), 'days');
    }, [firstOpenedAt]);
    function handleClose() {
        userActivity.handleModalClose();
    }
    function handleRateSubmit(selectedRate) {
        userActivity.setCurrentRate(selectedRate);
    }
    function handleStoreRedirect() {
        userActivity.handleStoreRedirect();
    }
    function handleFeedbackSubmit(feedbackText) {
        return userActivity.handleFeedbackSubmit(feedbackText);
    }
    function handleSkip() {
        userActivity.handleSkip();
    }
    const viewElement = useMemo(() => {
        const rate = userActivity.currentRate;
        if (!rate)
            return _jsx(RateView, { onRateSubmit: handleRateSubmit });
        if (rate === 5)
            return _jsx(RateTopView, { onRateUsOnStore: handleStoreRedirect });
        return _jsx(LeaveFeedbackView, { onSubmit: handleFeedbackSubmit, onSkip: handleSkip });
    }, [userActivity.currentRate]);
    useEffect(() => {
        if (isVisible) {
            analytics.track({
                eventType: 'feedback_rating_displayed',
                event_trigger_type: userActivity.currentTriggerAction,
                event_additional_info: {
                    days_since_installation,
                    total_contact_reveals_lifetime: totalContactRevealsCount,
                },
            });
        }
    }, [isVisible]);
    return (_jsx(ModalStyled, { isVisible: isVisible, onClose: handleClose, children: _jsx(AnalyticsContextProvider, { event_value: userActivity.currentRate, event_trigger_type: userActivity.currentTriggerAction || undefined, event_additional_info: { days_since_installation, total_contact_reveals_lifetime: totalContactRevealsCount }, children: viewElement }) }));
});
export default RateExtensionModal;
